import loadImageObject from './loadImageObject';

const getWidthAndHeightOfImageUrl = async imageUrl => {
  const image = await loadImageObject(imageUrl);

  return { width: image.width, height: image.height };
};

export default getWidthAndHeightOfImageUrl;
